import { render } from "./alertPaye.vue?vue&type=template&id=4b0c4f1e&scoped=true"
import script from "./alertPaye.vue?vue&type=script&lang=js"
export * from "./alertPaye.vue?vue&type=script&lang=js"

import "./alertPaye.vue?vue&type=style&index=0&id=4b0c4f1e&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0c4f1e"]])

export default __exports__